import { CarouselButtonSchema, MessageStepSchema } from '@feedyou-ai/feedbot-schema'
import { CollapseUnion, Mutable, SelectedMutations } from '@feedyou/utils'
import arrayMove from 'array-move'
import update from 'immutability-helper'

import { Action, actionTypes } from './action'
import { updateStepMutation } from '../../Step/StepService'

export function messageReducer(
  step: Mutable<MessageStepSchema>,
  action: Action,
  selectedMutations: SelectedMutations
) {
  switch (action.type) {
    case actionTypes.ADD_CAROUSEL_ITEM: {
      const command = step.carousel ? '$push' : '$set'
      return update<MessageStepSchema, any>(step, {
        carousel: { [command]: [{ id: action.payload.id }] }
      })
    }

    case actionTypes.REMOVE_CAROUSEL_ITEM: {
      const itemIndex = action.payload

      return update(step, { carousel: { $splice: [[itemIndex, 1]] } })
    }

    case actionTypes.SET_MESSAGE:
      if (selectedMutations) {
        return updateStepMutation(step, step.type, action.payload, selectedMutations)
      }
      return update(step, { message: { $set: action.payload } })

    case actionTypes.EDIT_PROPERTY: {
      const { itemIndex, type, value } = action.payload

      return update(step, {
        carousel: items =>
          items?.map((item, index) =>
            index === itemIndex
              ? selectedMutations
                ? updateStepMutation(item as any, type, value, selectedMutations) // Tady se ta step mutation funkce zdánlivě zneužívá ke carousel itemu
                : update(item, { [type]: { $set: value } })
              : item
          )
      })
    }

    case actionTypes.ADD_ITEM_BUTTON: {
      const { itemIndex, properties } = action.payload
      const { msg, title } = properties as CollapseUnion<typeof properties>

      return update(step, {
        carousel: (items: MessageStepSchema['carousel']) =>
          items?.map((item, index) => {
            if (index === itemIndex) {
              const command = item.buttons ? '$push' : '$set'
              console.log('ADD BUTTON', item, command, properties)
              if (selectedMutations) {
                return update(item, {
                  buttons: {
                    [command]: [
                      {
                        ...updateStepMutation(
                          item as any, // Tady se ta step mutation funkce zdánlivě zneužívá k button itemu
                          'title',
                          (title || msg) as string,
                          selectedMutations
                        )
                      }
                    ]
                  } as any // immutability helper bs
                })
              }

              return update(item, {
                buttons: { [command]: [{ ...properties }] }
              } as any) // immutability helper bs
            } else {
              return item
            }
          })
      })
    }

    case actionTypes.EDIT_ITEM_BUTTON: {
      const { itemIndex, buttonIndex, properties } = action.payload

      return update(step, {
        carousel: items =>
          items?.map((item, index) => {
            if (index !== itemIndex) {
              return item
            }

            return update(item!, getUpdatedButtons(properties, buttonIndex, selectedMutations))
          })
      })
    }

    case actionTypes.MOVE_CAROUSEL_ITEM: {
      let { srcIndex, destIndex } = action.payload

      if (srcIndex < destIndex) {
        destIndex--
      }

      return update(step, {
        carousel: items => items && arrayMove(items, srcIndex, destIndex)
      })
    }

    default:
      return step
  }
}

function getUpdatedButtons(
  properties: CarouselButtonSchema,
  buttonIndex: number,
  selectedMutations?: SelectedMutations
) {
  return {
    buttons: (buttons: CarouselButtonSchema[] | undefined) =>
      buttons?.map((button: CarouselButtonSchema, index: number) => {
        if (index !== buttonIndex) {
          return button
        }

        return getUpdatedButton(button, properties, selectedMutations)
      })
  }
}

function getUpdatedButton(
  button: Mutable<CarouselButtonSchema>,
  properties: CarouselButtonSchema,
  selectedMutations?: SelectedMutations
) {
  if (!selectedMutations) {
    return { ...button, ...properties }
  }

  const { msg, url, title } = properties

  const buttonWithUpdatedUrl = getButtonWithUpdatedUrl(button, url || '', selectedMutations)

  const buttonWithUpdatedTitle = getButtonWithUpdatedTitle(
    buttonWithUpdatedUrl,
    title || '',
    selectedMutations
  )

  const buttonWithUpdatedMessage = getButtonWithUpdatedMessage(
    buttonWithUpdatedTitle,
    msg || '',
    selectedMutations
  )

  return buttonWithUpdatedMessage
}

function getButtonWithUpdatedUrl(
  button: Mutable<CarouselButtonSchema>,
  url: string | undefined,
  selectedMutations: SelectedMutations
): Mutable<CarouselButtonSchema> {
  if (!url) {
    return button
  }

  return updateStepMutation(button as any, 'url', url || '', selectedMutations) // Tady se ta step mutation funkce zdánlivě zneužívá k mutaci něčeho jiného
}

function getButtonWithUpdatedTitle(
  button: Mutable<CarouselButtonSchema>,
  title: string | undefined,
  selectedMutations: SelectedMutations
): Mutable<CarouselButtonSchema> {
  if (!title) {
    return button
  }

  return updateStepMutation(button as any, 'title', title || '', selectedMutations) // Tady se ta step mutation funkce zdánlivě zneužívá k mutaci něčeho jiného
}

function getButtonWithUpdatedMessage(
  button: Mutable<CarouselButtonSchema>,
  msg: string | undefined,
  selectedMutations: SelectedMutations
): Mutable<CarouselButtonSchema> {
  if (!msg) {
    return button
  }

  return updateStepMutation(button as any, 'msg', msg || '', selectedMutations) // Tady se ta step mutation funkce zdánlivě zneužívá k mutaci něčeho jiného
}
